import { Button, Grid, Paper, Typography } from '@material-ui/core'
import React, { useEffect } from 'react'
import LoginPagesWrapper from '../../../components/LoginPagesWrapper'
import Carousel from 'react-material-ui-carousel'
import { compose } from 'recompose'
import { injectIntl } from 'react-intl'
import exampleChartReport from '../../../assets/images/example_chart_report_hr.png'
import exampleMessage from '../../../assets/images/example_message_hr.png'
import exampleXRay from '../../../assets/images/example_x-ray_hr.png'
import { Link, withRouter } from 'react-router-dom'
import AppleAppInstall from '../../../assets/images/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg'
import AndroidAppInstall from '../../../assets/images/google-play-badge.png'
import { set, setWithExpirationDate } from '../../../utilties/cookies'
import queryString from 'query-string'
import { useDispatch, useSelector } from 'react-redux'
import { caseIdSelector, teamBackgroundIsLoadingSelector, teamBackgroundSelector, teamLogoIsLoadingSelector, teamLogoSelector } from '../../../redux/selectors'
import defaultBackground from '../../../assets/images/default-bg.png'
import defaultLogo from '../../../assets/images/logo_benchmarc.svg'
import { getTeamBackground, getTeamBackgroundByEmail, getTeamBackgroundByEncryptedLink, getTeamLogo, getTeamLogoByEmail, getTeamLogoByEncryptedLink } from '../../../redux/actions'

const copyToClipboardFallback = (value) => {
    let successful = false;

    try
    {
        var textArea = document.createElement("textarea");
        textArea.value = value;

        textArea.style.top = "0";
        textArea.style.left = "0";
        textArea.style.position = "fixed";

        document.body.appendChild(textArea);

        textArea.focus();
        textArea.select();

        successful = document.execCommand('copy');

        document.body.removeChild(textArea);
    }
    catch (err)
    {
        console.error('Unable to copy', err);
    }
}

const copyToClipBoard = (value) => {
    copyToClipboardFallback(value)

	navigator.permissions.query({ name: 'clipboard-write' }).then((result) => {
		if (result.state == 'granted' || result.state == 'prompt') {
			navigator.clipboard.writeText(value)
		} else {
			console.error('Access to clipboard is denied');
		}
	})
}

const Item = ({item}) => {
    return (
        <div
            style={{
                height: '40vh', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center'
            }}
        >
            <img
                src={item.imgSource}
                style={{
                    width: '100%',
                    height: 'auto'
                }}
            />
        </div>
    )
}

const InstallApp = ({
    intl,
    location
}) => {
    const items = [
        {
            imgSource: exampleChartReport
        },
        {
            imgSource: exampleMessage
        },
        {
            imgSource: exampleXRay
        }
    ]

    const dispatch = useDispatch()

    const backgroundLogoUrl = useSelector(teamBackgroundSelector)
    const teamLogoUrl = useSelector(teamLogoSelector)
    const teamLogoIsLoading = useSelector(teamLogoIsLoadingSelector)
    const teamBackgroundIsLoading = useSelector(teamBackgroundIsLoadingSelector)

    const caseId = useSelector(caseIdSelector)

    const appStoreUrl = 'https://apps.apple.com/us/app/benchmarc-health/id1635544500'
    const googlePlayUrl = 'https://play.google.com/store/apps/details?id=com.incytes.incytespatientmobile'

    const appInstallUrl = navigator.userAgent.indexOf("Mac OS") != -1 ? appStoreUrl : googlePlayUrl

    useEffect(
        () => {
            let params = queryString.parse(location.search)

            if (caseId) {
                dispatch(getTeamLogo())
                dispatch(getTeamBackground())
            }
            else if (params.email) {
                dispatch(getTeamLogoByEmail(params.email))
                dispatch(getTeamBackgroundByEmail(params.email))
            }
            else if (params.data) {
                dispatch(getTeamLogoByEncryptedLink(params.data))
                dispatch(getTeamBackgroundByEncryptedLink(params.data))
            }
        },
        [caseId, location]
    )

    const onContinueWithBrowser = () => {
        let expirationDate = new Date()
        expirationDate.setDate(expirationDate.getDate() + 365)
        setWithExpirationDate('continueWithBrowser', true, expirationDate)
        
        window.location.reload()
    }

    const downloadHandler = () => {
        //TODO: replace with the method from utilities.js
        copyToClipBoard(window.location.href)
    }

    return (
		<LoginPagesWrapper
            logoUrl={teamLogoUrl || !teamLogoIsLoading && defaultLogo}
            backgroundUrl={backgroundLogoUrl || !teamBackgroundIsLoading && defaultBackground}
			hideMenu={true}
		>
            <div style={{ display: 'flex', justifyContent: 'center', width: '100%', marginTop: '100px' }}>
                <Paper style={{ maxWidth: '479px', width: '100%', height: '100%', margin: '0 0 30px', padding: '0' }} square>
                    <Grid
                        container
                        direction='column'
                        alignItems='center'
                        style={{
                            width: '100%',
                            paddingLeft: '5vh',
                            paddingRight: '5vh', 
                            paddingBottom: '30px'
                        }}
                    >
                        <Grid
                            item
                            xs={12}
                            style={{
                                paddingTop: '35px',
                                textAlign: 'center'
                            }}
                        >
							<Typography
                                variant="h2"
                            >
                                { intl.formatMessage({ id: 'app.install.title' }) }
                            </Typography>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            style={{
                                width: '100%',
                                paddingTop: '15px'
                            }}
                        >
                            <Carousel
                                indicators={false}
                                navButtonsAlwaysVisible={true}
                                style={{
                                    width: '500px'
                                }}
                                height={undefined}
                            >
                                {
                                    items.map( (item, i) => <Item key={i} item={item} /> )
                                }
                            </Carousel>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            style={{
                                paddingTop: '15px'
                            }}
                        >
                            <Button
                                variant='contained'
                                color='primary'
                                style={{
                                    width: '300px',
                                    margin: '0 -30px'
                                }}
                                onClick={downloadHandler}
                                href={appInstallUrl}
                            >
                                { intl.formatMessage({ id: 'app.install.downloadText' }) }
                            </Button>
                        </Grid>
                        <Grid
                            item
                            style={{
                                paddingTop: '5px'
                            }}
                        >
                            { intl.formatMessage({ id: 'app.install.orText' }) }
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            style={{
                                paddingTop: '5px'
                            }}
                        >
                            <Button
                                variant='outlined'
                                color='secondary'
                                style={{
                                    width: '300px',
                                    margin: '0 -30px'
                                }}
                                onClick={onContinueWithBrowser}
                            >
                                { intl.formatMessage({ id: 'app.install.browserText' }) }
                            </Button>
                        </Grid>
                        <Grid
                            item
                            style={{
                                paddingTop: '10px'
                            }}
                       >
                            <Grid
                                container
                                spacing={3}
                                alignItems='center'
                                style={{ justifyContent: 'center', marginTop: '30px'}}
                            >
                                <Grid
                                    item
                                >
                                        <img
                                            src={AppleAppInstall}
                                            style={{
                                                padding: '0 10px'
                                            }}
                                       >
                                        </img>
                                </Grid>
                                <Grid
                                    item
                                >
                                        <img
                                            style={{
                                                width: '140px',
                                                height: '60px'
                                            }}
                                            src={AndroidAppInstall}>
                                        </img>
                                </Grid>
                            </Grid>
                        </Grid>
                   </Grid>
                </Paper>
            </div>
        </LoginPagesWrapper>
    )
}

const enhance = compose(
    injectIntl,
    withRouter
)

export default enhance(InstallApp)